import { render, staticRenderFns } from "./assistant.vue?vue&type=template&id=3d9df5ab&scoped=true"
import script from "./assistant.vue?vue&type=script&lang=ts"
export * from "./assistant.vue?vue&type=script&lang=ts"
import style0 from "./assistant.vue?vue&type=style&index=0&id=3d9df5ab&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_f33b182414a87044fb4ff91041025cb4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9df5ab",
  null
  
)

export default component.exports